const columns = [
    {
        name: 'Company',
        selector: (row) => row.company.name,
    },
    {
        name: 'Category',
        selector: (row) => row.category,
    },
    {
        name: 'Action',
        selector: (row) => row.actions,
    }
]

export default columns